import DOMPurify from 'dompurify';
import { Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { sanitizeLinks } from '../../../../lib/htmlSanitization';

DOMPurify.addHook('afterSanitizeAttributes', node => {
  sanitizeLinks(node);

  // TODO: We can remove this later when B/E is released
  if (node instanceof HTMLElement && node.hasAttribute('style')) {
    // Allowing style attribute can be risky, we want to allow only color in the style

    const allowedCSSProperties = ['color'];
    const styles = node.style.cssText.split(';').filter(style => {
      const [property] = style.split(':').map(s => s.trim());
      return property && allowedCSSProperties.includes(property);
    });

    node.setAttribute('style', styles.join(';'));
  }
});

export const Summary = ({ content }: { content: string }) => {
  // You can use this to have a test response from backend.
  // const content =
  //   'Trigger when <span class="field">Amount Due</span> is greater than <span class="value">1000</span>, using default value of <span class="value">0</span> if field is missing';

  return (
    <Typography
      variant="body2"
      color="text.primary"
      sx={{
        '.field': { fontWeight: 'bold' },
        '.value': { fontWeight: 'bold' },
        '.field-id': {
          fontFamily: 'monospace',
          fontSize: '0.85em',
          backgroundColor: 'action.hover',
          px: 0.5,
          py: 0.25,
          borderRadius: borderRadius('s'),
        },
        '.projection-table': {
          width: '100%',
          mt: 1,
          '& td': {
            py: 0.5,
            verticalAlign: 'top',
          },
          '& td:first-of-type': {
            fontWeight: 500,
            pr: 2,
            whiteSpace: 'nowrap',
          },
        },
      }}
      // oxlint-disable-next-line react/no-danger -- oxlint stricter than eslint — sanitized HTML, pre-existing usage
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(content, {
          // `strong` / `style` can go away but we might need to be compatible with previous backend.
          ALLOWED_TAGS: ['span', 'strong', 'td', 'tr', 'b', 'table', 'th'],
          ALLOWED_ATTR: ['style', 'class'],
        }),
      }}
    />
  );
};
